export const DynamicPaths = {
  BASKET_ITEMS: 'basket/items/{recommendationId}',
  ORDERS: 'orders/{orderId}',
  ORDERS_CANCEL: 'orders/{orderId}/cancel',
  ORDERS_RESHOP: 'orders/{orderId}/reshop',
  ORDERS_CHANGE: 'orders/{orderId}/change',
  LOCATIONS_AIRPORT: 'search/airport/{iataCode}',
  TINY_URL: 'tiny-url/{shortUrl}',
}

const AVIOS_BASE_PATH = 'spend-avios/rewards'

/**
 * Removes Query Strings from URLs to obtain Path
 * @param url string
 * @returns string
 */
export const convertUrlToPath = (url: string): string => {
  return url.split('?')[0]
}

/**
 * Remove Avios base path for Avios.com and find if request base route is `api` or `next-api`
 * @param path
 * @returns string
 */
const getBaseRoute = (path: string): string => {
  if (path.includes(AVIOS_BASE_PATH)) {
    const parts = path.split('/')
    return parts.slice(1, 4).join('/')
  }

  return path.split('/')[1]
}

/**
 * Removes dynamic vars from paths and replaces them with a variable identifier
 * @param path
 * @returns string
 */
export const sanitizeDynamicPaths = (path: string): string => {
  const baseRoute = getBaseRoute(path)
  let sanitizedPath: string

  if (
    baseRoute !== 'api' &&
    baseRoute !== 'next-api' &&
    baseRoute !== `${AVIOS_BASE_PATH}/next-api`
  ) {
    sanitizedPath = path
  } else if (path.includes('/basket/items/')) {
    sanitizedPath = `/${baseRoute}/${DynamicPaths.BASKET_ITEMS}`
  } else if (
    path.includes('/orders/') &&
    !path.includes('/cancel') &&
    !path.includes('/reshop') &&
    !path.includes('/change') &&
    !path.includes('/payment/capture-context')
  ) {
    sanitizedPath = `/${baseRoute}/${DynamicPaths.ORDERS}`
  } else if (path.includes('/orders/') && path.includes('/cancel')) {
    sanitizedPath = `/${baseRoute}/${DynamicPaths.ORDERS_CANCEL}`
  } else if (path.includes('/orders/') && path.includes('/reshop')) {
    sanitizedPath = `/${baseRoute}/${DynamicPaths.ORDERS_RESHOP}`
  } else if (path.includes('/orders/') && path.includes('/change')) {
    sanitizedPath = `/${baseRoute}/${DynamicPaths.ORDERS_CHANGE}`
  } else if (path.includes('/airport/')) {
    sanitizedPath = `/${baseRoute}/${DynamicPaths.LOCATIONS_AIRPORT}`
  } else if (path.includes('/tiny-url/')) {
    sanitizedPath = `/${baseRoute}/${DynamicPaths.TINY_URL}`
  } else {
    sanitizedPath = path
  }

  return sanitizedPath
}
